// composables/useMapToken.js
import { readonly, ref } from 'vue';
import axios from 'axios'

// Shared state across all component instances
const mapToken = ref(null)
let tokenExpirationTimer = null

export function useMapToken() {
    const getMapToken = async () => {
        if (mapToken.value) {
            return mapToken.value
        }

        try {
            const response = await axios.get('/api/map/token')
            mapToken.value = response.data.token

            if (tokenExpirationTimer) {
                clearTimeout(tokenExpirationTimer)
            }

            tokenExpirationTimer = setTimeout(() => {
                mapToken.value = null
            }, 20 * 60 * 1000)

            return mapToken.value
        } catch (error) {
            console.error('Failed to get map token:', error)
            throw error
        }
    }

    const clearMapToken = () => {
        mapToken.value = null
        if (tokenExpirationTimer) {
            clearTimeout(tokenExpirationTimer)
        }
    }

    const addMapTokenToUrl = async (url) => {
        if (!mapToken.value) {
            try {
                await getMapToken()
            } catch (error) {
                console.error('Failed to get map token for URL:', error)
                return url
            }
        }
        const separator = url.includes('?') ? '&' : '?'
        return `${url}${separator}token=${encodeURIComponent(mapToken.value)}`
    }

    return {
        mapToken: readonly(mapToken),
        getMapToken,
        clearMapToken,
        addMapTokenToUrl
    }
}